import $$ from "Dom7";
import actions from "../js/actions.js";
import "../css/forgot-password.css"; // Import Routes

import URLS from "../js/Urls.js";
export default {
  on: {
    pageInit: () => {
      var WrongCredentials = app.f7.toast.create({
        text: "Wrong Username or Password",
        position: "center",
        closeTimeout: 2000
      });
      var toastCheckConnection = app.f7.toast.create({
        text: "Check your internet connection",
        position: "center",
        closeTimeout: 1500
      });
      $$(".toolbar.toolbar-bottom").css("display", "none");
      $$("#login-button").on("click", async () => {
        var username = $$("#FogEmail").val();
        var password = $$("#PswLogin").val(); // if(username == "" && password == ""){
        //   return;
        // }
        //Check pass
        // if(username === "test" && password ==="test"){
        //     //mainView.router.navigate('/pmshome/');
        //     localStorage.setItem("islogin",1);
        //     ;
        //     // Framework7.instance.views.main.router.load('/dashboard/');
        //     Framework7.instance.views.main.router.navigate('/dashboard/', {reloadCurrent: true});
        //     // app.views.main.router.navigate('/pmshome/', {reloadCurrent: true});
        // }else{
        //   toastCenter.open();
        // }

        var User = {
          Username: username,
          Password: password
        };
        app.f7.preloader.show(); // wait for 3 seconds
        // await new Promise(resolve => setTimeout(resolve, 3000));

        let result; // await app.f7.request.promise.get('https://jsonplaceholder.typicode.com/todos/1', {})
        //   .then((data) => {
        //     ;
        //     actions.SetResult(data.data);
        //   });

        try {
          await app.f7.request.promise.post(URLS.login, {
            User
          }).then(res => {
            var myObj = JSON.parse(res.data);

            if (myObj.SuccessLogin === true) {
              localStorage.setItem("islogin", 1);
              actions.LoginSetResult(myObj);
              app.f7.views.main.router.navigate("/main/", {
                transition: "f7-dive"
              });
            } else {
              app.f7.preloader.hide();
              WrongCredentials.open();
            }
          });
        } catch (err) {
          toastCheckConnection.open();
        } // await app.f7.request.promise.post('https://pmslocal.abouthotelier.com/Login/AppLogin', { user })
        //   .then((data) => {
        //     ;
        //     actions.SetResult(data.data);
        //   });

      });
    }
  },
  id: '02eb4d015a',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=forgot-password><!-- Top Navbar --><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a class="link back"><i class="icon icon-back"></i></a></div><div class=title>Forgot Password</div></div></div><div class="page-content login"><div class=login-logo></div><span class=Roomrack-title>ROOMRACK </span><span class=room-sub>CLOUD HOTEL PMS</span><div class=login-text><span><b>Forgotten your password?</b></span><br><span>To reset your password , enter your email addrress.</span></div><div action="" id=my-login-screen><div class=container><div class="row square"><div class=col-10><i class=material-icons style="margin-top: 8px">mail_outline</i></div><div class=col-90><input type=text id=FogEmail placeholder="Email ID here" name=email required></div></div><div class=row><button type=submit id=ResetPswLink>Send Link</button></div></div></div><div class=footer><div class=row style="color: #d4d8db; font-size: 12px"><span>Please reach out to us for any help</span></div><div class=row style="margin: 15px"><div class=col-50 style="display: inline-flex"><div class=col><i class=material-icons>phone</i></div><div class=col>+30 210 3000 921</div><!-- <i class="material-icons">\r\n                    phone\r\n                  </i>\r\n                  <p>+30 210 3000 921 </p> --></div><div class=col-50 style="display: inline-flex"><div class=col><i class=material-icons>email</i></div><div class=col>info@abouthotelier.com</div><!-- <i class="material-icons">\r\n                    email\r\n                  </i>\r\n                  <p>info@abouthotelier.com </p> --></div></div></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};